import { useCallback, useState } from 'react';
import { toast } from 'sonner';
import { buildShareLink, copyToClipboard } from '@/shared/utils/clipboard';
import { verificationService } from '../services/verification.service';

interface UseCopyRefereeLinkParams {
  candidateId: string;
  experienceId: string;
}

interface UseCopyRefereeLinkResult {
  copyRefereeLink: (verificationId: string, currentShareId: string) => void;
  isCopying: boolean;
}

export function useCopyRefereeLink({
  candidateId,
  experienceId,
}: UseCopyRefereeLinkParams): UseCopyRefereeLinkResult {
  const [isCopying, setIsCopying] = useState(false);

  const copyRefereeLink = useCallback(
    (verificationId: string, currentShareId: string): void => {
      if (isCopying) return;
      setIsCopying(true);

      verificationService
        .refreshShareLink(candidateId, experienceId, verificationId)
        .then((result) => {
          copyToClipboard(buildShareLink('referee', result.shareId));
          toast.success('Link copied to clipboard');
        })
        .catch(() => {
          copyToClipboard(buildShareLink('referee', currentShareId));
          toast.error('Could not verify link freshness. Link may be expired.');
        })
        .finally(() => {
          setIsCopying(false);
        });
    },
    [candidateId, experienceId, isCopying]
  );

  return { copyRefereeLink, isCopying };
}
